import { render, staticRenderFns } from "./ChallengePage.vue?vue&type=template&id=435367cd&"
import script from "./ChallengePage.vue?vue&type=script&lang=js&"
export * from "./ChallengePage.vue?vue&type=script&lang=js&"
import style0 from "./ChallengePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports